<div class="ibox detailed-view-ibox"
     *ngIf="serviceRequestService.showDetailedView && serviceRequestService.selectedItemData">
    <div class="detailed-view-header">
        <a *ngIf="serviceRequestService.selectedItemData.suiteId != '0'
                     && serviceRequestService.selectedItemData.suiteNumber
                     && !authenticationService.userIsResident"
            (click)="directoryService.previousUrl = '/service-request'"
            [routerLink]="['/directory/item/' + serviceRequestService.selectedItemData.suiteId + '/residents/']">
            <span class="suite-name m-r-sm mtv-primary-color">{{serviceRequestService.selectedItemData.suiteNumber}}</span>
        </a>
        <span class="suite-name m-r-sm mtv-primary-color default-cursor"
              *ngIf="serviceRequestService.selectedItemData.suiteId == '0'">
            {{serviceRequestService.selectedItemData.suiteNumber}}
        </span>
        <span class="building-name">{{serviceRequestService.selectedItemData.buildingName}}</span>
        <span class="close-detailed-view" (click)="serviceRequestService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
            <form #form="ngForm"
                  *ngIf="serviceRequestService.selectedItemData"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div class="detailed-view-navigation">
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'info';"
                             [ngClass]="{'active': navPosition == 'info'}">
                            Ticket Info
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'comments';"
                             [ngClass]="{'active': navPosition == 'comments'}">
                            Comments
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'history';"
                             [ngClass]="{'active': navPosition == 'history'}">
                            History
                        </div>
                    </div>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'info'">
                    <div class="m-b-sm">
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.open"
                              class="label label-open">
                            Open
                        </span>
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.inProgress"
                              class="label label-in-progress">
                            In Progress
                        </span>
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.onHold"
                              class="label label-on-hold">
                            On Hold
                        </span>
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.closed"
                              class="label label-closed">
                            Closed
                        </span>
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.archived"
                              class="label label-archived">
                            Archived
                        </span>
                        <span *ngIf="serviceRequestService.selectedItemData.status === status.cancelled"
                              class="label label-cancelled">
                            Cancelled
                        </span>
                    </div>

                    <!--** Request Type ** -->
                    <div class="row m-b-xs"
                        (dblclick)="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident
                                    && setEditModeFor(serviceRequestService.selectedItemData, 'requestType', true)">
                        <div class="dv-value col-sm-12"
                             *ngIf="!serviceRequestService.selectedItemData.formFields.requestType.editMode">
                            <span *ngIf="serviceRequestService.selectedItemData.serviceRequestType
                                         || serviceRequestService.selectedItemData.serviceRequestTypeOther">
                                {{serviceRequestService.selectedItemData.serviceRequestTypeOther ||
                                  getTypeById(serviceRequestService.selectedItemData.serviceRequestType.id) || '-'}}
                            </span>

                            <span *ngIf="!serviceRequestService.selectedItemData.serviceRequestType.id
                                         && serviceRequestService.selectedItemData.serviceRequestType.name">
                                {{ serviceRequestService.selectedItemData.serviceRequestType.name || '-' }}
                            </span>

                            <i class="fa fa-pencil pull-right"
                                (click)="setEditModeFor(serviceRequestService.selectedItemData, 'requestType', true)"
                                *ngIf="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-12"
                             *ngIf="serviceRequestService.selectedItemData.formFields.requestType.editMode">
                            <select class="form-control"
                                    name="requestType"
                                    [ngModel]="serviceRequestService.selectedItemData.serviceRequestType.id || 0"
                                    [disabled]="!serviceRequestService.requestTypesForDetailedView.length">
                                <option value="" hidden></option>
                                <option [value]="item.id"
                                        *ngFor="let item of serviceRequestService.requestTypesForDetailedView">
                                    {{item.name}}
                                </option>
                            </select>

                            <button *ngIf="form.value.requestType != 0"
                                    type="button"
                                    (click)="applyChanges(serviceRequestService.selectedItemData, form, {serviceRequestType: form.value.requestType}, 'requestType')">
                                    <i class="fa fa-check"></i></button>
                            <button *ngIf="form.value.requestType == 0"
                                    type="button"
                                    (click)="applyChanges(serviceRequestService.selectedItemData, form, {serviceRequestTypeOther: form.value.requestTypeOther}, 'requestType')">
                                    <i class="fa fa-check"></i>
                            </button>

                            <button type="button"
                                    (click)="setEditModeFor(serviceRequestService.selectedItemData, 'requestType', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>

                        <div *ngIf="form.value.requestType == 0"
                             class="dv-value-edit col-sm-12"
                             [class.hidden]="!serviceRequestService.selectedItemData.formFields.requestType.editMode">
                            <input class="form-control"
                                   type="text"
                                   name="requestTypeOther"
                                   placeholder="Other Type"
                                   [ngModel]="serviceRequestService.selectedItemData.serviceRequestTypeOther"
                                   (keyup.enter)="applyChanges(serviceRequestService.selectedItemData, form, {requestType: form.value.requestTypeOther}, 'requestType')">
                        </div>
                    </div>
                    <div (click)="changeServiceRequestReadStatus($event, -1, serviceRequestService.selectedItemData)"
                         *ngIf="(serviceRequestService.selectedItemData.status !== status.closed &&
                                serviceRequestService.selectedItemData.status !== status.cancelled &&
                                serviceRequestService.selectedItemData.status !== status.archived) &&
                                (authenticationService.userIsResident &&
                                serviceRequestService.residentAccessController(action.commentCreate))">
                        <a class="btn btn-default btn-sm dropdown-toggle m-b-sm m-t-sm">Add Comment</a>
                    </div>

                    <!--** Priority ** -->
                    <div class="row m-b-xs"
                         (dblclick)="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident
                                     && setEditModeFor(serviceRequestService.selectedItemData, 'priority', true)">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip">
                            Priority
                        </div>
                        <div class="dv-value col-sm-9"
                             *ngIf="!serviceRequestService.selectedItemData.formFields.priority.editMode">
                            <span class="text-capitalize">
                                {{serviceRequestService.selectedItemData.priority || '-'}}
                            </span>

                            <i class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(serviceRequestService.selectedItemData, 'priority', true)"
                               *ngIf="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident"
                               data-toggle="tooltip"
                               data-placement="top"
                               title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-9"
                             *ngIf="serviceRequestService.selectedItemData.formFields.priority.editMode">
                            <select class="form-control"
                                    name="priority"
                                    required
                                    [ngModel]="serviceRequestService.selectedItemData.priority">
                                <option value="" hidden></option>
                                <option *ngFor="let priority of requestPriorities" [value]="priority.name">
                                    {{priority.displayName}}
                                </option>
                            </select>

                            <button type="button"
                                    (click)="applyChanges(serviceRequestService.selectedItemData, form, {priority: form.value.priority}, 'priority')">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button"
                                    (click)="setEditModeFor(serviceRequestService.selectedItemData, 'priority', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--  ** Ticket # **  -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip">
                            Ticket #
                        </div>
                        <div class="dv-value col-sm-9">
                            {{serviceRequestService.selectedItemData.serviceRequestNumber}}
                        </div>
                    </div>

                    <!--  ** Building / Unit / Resident **  -->
                    <div class="row m-b-xs"
                         *ngIf="serviceRequestService.buildings.length > 1"
                         (dblclick)="!authenticationService.userIsResident && setEditModeFor(serviceRequestService.selectedItemData, 'building', true, form)">
                        <div class="dv-label col-md-3">
                            <label>Building</label>
                        </div>
                        <div class="dv-value col-md-9"
                             *ngIf="!serviceRequestService.selectedItemData.formFields.building.editMode">
                            <span>{{serviceRequestService.selectedItemData.buildingName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && serviceRequestService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(serviceRequestService.selectedItemData, 'building', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-9"
                             *ngIf="serviceRequestService.selectedItemData.formFields.building.editMode">
                            <select class="form-control"
                                    name="building"
                                    [disabled]="buildingSelectIsDisabled"
                                    (change)="changeBuilding($event.target.value, form)"
                                    [ngModel]="serviceRequestService.selectedItemData.buildingId">
                                <option value=""></option>
                                <option *ngFor="let building of serviceRequestService.buildings" [value]="building.id">
                                    {{building.name}}
                                </option>
                            </select>
                            <button type="button" (click)="applyChanges(serviceRequestService.selectedItemData, form, {building: form.value.building}, 'building')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(serviceRequestService.selectedItemData, 'building', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && setEditModeFor(serviceRequestService.selectedItemData, 'unit', true, form)">
                        <div class="dv-label col-md-3">
                            <label>Unit</label>
                        </div>
                        <div class="dv-value col-md-9" *ngIf="!serviceRequestService.selectedItemData.formFields.unit.editMode">
                            <span>{{serviceRequestService.selectedItemData.suiteNumber || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && serviceRequestService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(serviceRequestService.selectedItemData, 'unit', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-9"
                             *ngIf="serviceRequestService.selectedItemData.formFields.unit.editMode">
                            <search-select [ngModel]="serviceRequestService.selectedItemData.suiteId"
                                           name="unit"
                                           required
                                           style="height: 26px;"
                                           (ngModelChange)="changeUnit($event, form)"
                                           [data]="suiteToSearchSelect(suites)">
                            </search-select>
                            <input *ngIf="form.value.unit === 0"
                                   class="form-control"
                                   [ngModel]="serviceRequestService.selectedItemData.suiteNumber"
                                   name="otherSuite"
                                   placeholder="Other Unit Number"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.building && !suites.length"></spinner>
                            <button type="button" (click)="applyChanges(serviceRequestService.selectedItemData, form, {suite: form.value.unit}, 'unit')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(serviceRequestService.selectedItemData, 'unit', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs"
                         (dblclick)="!authenticationService.userIsResident && setEditModeFor(serviceRequestService.selectedItemData, 'resident', true, form)">
                        <div class="dv-label col-md-3">
                            <label>Resident</label>
                        </div>
                        <div class="dv-value col-md-9" *ngIf="!serviceRequestService.selectedItemData.formFields.resident.editMode">
                            <span>{{serviceRequestService.selectedItemData.residentFullName || '-'}}</span>
                            <i *ngIf="!authenticationService.userIsResident && serviceRequestService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(serviceRequestService.selectedItemData, 'resident', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-9" *ngIf="serviceRequestService.selectedItemData.formFields.resident.editMode">
                            <select class="form-control"
                                    (change)="changeResident($event.target.value)"
                                    [ngModel]="serviceRequestService.selectedItemData.residentId"
                                    name="resident" required #residentSelect
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">
                                    {{resident.fullName}}
                                </option>
                            </select>
                            <input *ngIf="residentSelect.value === '0'"
                                   class="form-control"
                                   placeholder="Other Resident Name"
                                   [ngModel]="serviceRequestService.selectedItemData.residentFullName"
                                   name="otherResident"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="form.value.unit && !residents.length"></spinner>
                            <button type="button" (click)="applyChanges(serviceRequestService.selectedItemData, form, {resident: form.value.resident}, 'resident')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(serviceRequestService.selectedItemData, 'resident', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--  ** Created By **  -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip">
                            Created By
                        </div>
                        <div class="dv-value col-sm-9">
                            {{serviceRequestService.selectedItemData.createdByFullName}}
                        </div>
                    </div>

                    <!--  ** Created At **  -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip">
                            Created On
                        </div>
                        <div class="dv-value col-sm-9">
                            {{serviceRequestService.selectedItemData.createdAt | date:'yyyy-MM-dd h:mma'}}
                        </div>
                    </div>

                    <!--** Assigned To ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-3 strong" data-placement="top" data-toggle="tooltip">
                            Assigned To
                        </div>
                        <div class="dv-value col-sm-9">
                            {{serviceRequestService.selectedItemData.assigneeName}}
                        </div>
                    </div>

                    <!--  ** Share Contact **  -->
                    <div class="row m-b-xs" (dblclick)="serviceRequestService.selectedItemData.isCanEdit
                                                        && setEditModeFor(serviceRequestService.selectedItemData, 'permissionToEnter', true)">
                        <div class="dv-label col-sm-4 strong share-contact-information">Grant Permission To Enter The Unit</div>
                        <div class="dv-value col-sm-8 share-contact-information" *ngIf="!serviceRequestService.selectedItemData.formFields.permissionToEnter.editMode">
                            <i *ngIf="serviceRequestService.selectedItemData.permissionToEnter == 1" class="icon-check"></i>
                            <i *ngIf="serviceRequestService.selectedItemData.permissionToEnter == 0" class="icon-close"></i>
                            <i class="fa fa-pencil pull-right"
                                *ngIf="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident"
                                (click)="setEditModeFor(serviceRequestService.selectedItemData, 'permissionToEnter', true)"
                                data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8 share-contact-information-select-width"
                             *ngIf="serviceRequestService.selectedItemData.formFields.permissionToEnter.editMode">
                            <select class="form-control"
                                    name="permissionToEnter"
                                    [ngModel]="+serviceRequestService.selectedItemData.permissionToEnter">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <button type="button"
                                    (click)="applyChanges(serviceRequestService.selectedItemData, form, {permissionToEnter: form.value.permissionToEnter}, 'permissionToEnter')">
                                    <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(serviceRequestService.selectedItemData, 'permissionToEnter', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <hr>
                    <!--  ** Description **  -->
                    <textarea-field [ngModel]="serviceRequestService.selectedItemData.description"
                                    name="description"
                                    [value]="serviceRequestService.selectedItemData.description"
                                    [tooltipText]="'Description'"
                                    [title]="'Description'"
                                    [noEdit]="authenticationService.userIsResident"
                                    (update)="onSubmit({description: form.value.description})">
                    </textarea-field>

                    <hr>

                    <!--  ** Notes **  -->
                    <textarea-field [ngModel]="serviceRequestService.selectedItemData.notes"
                                    name="notes"
                                    [value]="serviceRequestService.selectedItemData.notes"
                                    [tooltipText]="'Notes'"
                                    [title]="'Notes'"
                                    [noEdit]="authenticationService.userIsResident"
                                    (update)="onSubmit({notes: form.value.notes})">
                    </textarea-field>

                    <hr>

                    <!-- ___ Images  ___ -->
                    <div class="row m-b-sm" *ngIf="serviceRequestService.residentAccessController(action.requestAttachment)">
                        <div class="col-md-4">
                            <label>Images</label>
                        </div>
                        <div *ngIf="serviceRequestService.selectedItemData.isCanEdit" class="col-md-8">
                            <input type="file"
                                   name="attachment"
                                   accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                   id="add-attachment-btn"
                                   (change)="addFile($event)"
                                   [disabled]="disabledFileInput"
                                   hidden>
                            <label for="add-attachment-btn" class="btn mtv-primary-color">Add Image</label>
                        </div>
                    </div>
                    <table class="attachment-box">
                        <tr *ngFor="let array of serviceRequestService.selectedItemData.attachmentsToDisplay; let j = index">
                            <td *ngFor="let item of array; let i = index;" class="image-container">
                                <img class="image-attached" (click)="serviceRequestService.showAttachment(item)" [src]="item.path">
                                <div class="file-name">
                                    <div class="file-name-text">
                                        <a class="file-link" (click)="serviceRequestService.showAttachment(item)">
                                            {{item.name}}
                                        </a>
                                    </div>
                                    <i *ngIf="serviceRequestService.selectedItemData.isCanEdit && serviceRequestService.residentAccessController(action.requestAttachment)"
                                       class="fa fa-trash"
                                       style="opacity: 1;"
                                       (click)="removeFile(i, j)"
                                       title="Delete Attachment">
                                    </i>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <spinner [spinnerShow]="serviceRequestService.detailsViewSpinnerShow"></spinner>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'comments'">

                    <textarea class="form-control m-b-md"
                              *ngIf="!authenticationService.userIsResident ||
                                     (serviceRequestService.residentAccessController(action.commentCreate) &&
                                      serviceRequestService.selectedItemData.status !== status.closed &&
                                      serviceRequestService.selectedItemData.status !== status.cancelled &&
                                      serviceRequestService.selectedItemData.status !== status.archived)"
                              [ngClass]="{'internal' : commentObj.isPrivate && !commentObj.isPublic}"
                              name="comment"
                              [(ngModel)]="commentObj.comment"
                              [disabled]="isRequestInProgress"
                              placeholder="Leave a comment">
                    </textarea>

                    <div class="parcel-transit-modal m-b-sm" *ngIf="!authenticationService.userIsResident">
                        <div class="row m-t-md m-b-md">
                            <div class="col-sm-12">
                                <label class="img-checkbox">
                                    <input type="checkbox" checked disabled>
                                    <label><svg-checked></svg-checked></label>
                                    <span>Visible To Staff</span>
                                </label>
                            </div>
                        </div>
                        <div class="row m-t-md m-b-md">
                            <div class="col-sm-12">
                                <label class="img-checkbox">
                                    <input [ngModel]="!commentObj.isPrivate"
                                            (ngModelChange)="commentObj.isPrivate = !$event"
                                            type="checkbox"
                                            id="isPrivate"
                                            name="isPrivate">
                                    <label for="isPrivate"><svg-checked></svg-checked></label>
                                    <span>Visible To Resident</span>
                                </label>
                            </div>
                        </div>
                        <div *ngIf="serviceRequestService.selectedItemData.serviceRequestWorkerContract" class="row">
                            <div class="col-sm-12">
                                <label class="img-checkbox">
                                    <input [(ngModel)]="commentObj.isPublic"
                                           type="checkbox"
                                           id="isPublic"
                                           name="isPublic">
                                    <label for="isPublic"><svg-checked></svg-checked></label>
                                    <span>Visible To Vendor</span>
                                </label>
                            </div>
                            <div class="col-sm-4"></div>
                        </div>
                    </div>

                    <div *ngIf="!authenticationService.userIsResident ||
                                (serviceRequestService.residentAccessController(action.commentCreate) &&
                                serviceRequestService.selectedItemData.status !== status.closed &&
                                serviceRequestService.selectedItemData.status !== status.cancelled &&
                                serviceRequestService.selectedItemData.status !== status.archived)"
                         class="input-group-btn">
                        <button class="btn btn-outline-primary submit"
                                (click)="addComment()"
                                *ngIf="serviceRequestService.residentAccessController(action.commentCreate)"
                                [disabled]="isRequestInProgress">
                            Add Comment
                        </button>
                        <button *ngIf="!authenticationService.userIsResident && serviceRequestService.selectedItemData.status != status.archived"
                                data-toggle="dropdown"
                                class="btn btn-outline-primary dropdown-toggle"
                                type="button"
                                aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" style="top: 100%;"  *ngIf="!authenticationService.userIsResident">
                            <li (click)="addComment(status.inProgress)"
                                *ngIf="serviceRequestService.selectedItemData.status === status.open ||
                                       serviceRequestService.selectedItemData.status === status.onHold">
                                <a>Submit as In Progress</a>
                            </li>
                            <li (click)="addComment(status.onHold)"
                                *ngIf="serviceRequestService.selectedItemData.status !== status.onHold &&
                                       serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled">
                                <a>Submit as On Hold</a>
                            </li>
                            <li (click)="addComment(status.closed)"
                                *ngIf="serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled">
                                <a>Submit as Closed</a>
                            </li>
                            <li (click)="addComment(status.cancelled)"
                                *ngIf="serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled">
                                <a>Submit as Cancelled</a>
                            </li>
                            <li (click)="addComment(status.archived)"
                                *ngIf="serviceRequestService.selectedItemData.status != status.open &&
                                       serviceRequestService.selectedItemData.status != status.archived">
                                <a>Submit As Archived</a>
                            </li>
                        </ul>
                    </div>

                    <div class="comments-navigation m-t-sm" *ngIf="!authenticationService.userIsResident">
                        <div (click)="commentsNav = 'all'"
                             [ngClass]="{'active mtv-primary-border': commentsNav == 'all'}">
                            All <span class="badge-total mtv-primary-bg-color">{{getCommentsList('all').length}}</span>
                        </div>
                        <div (click)="commentsNav = 'public'"
                             [ngClass]="{'active mtv-primary-border': commentsNav == 'public'}">
                            Public
                            <span class="badge-total mtv-primary-bg-color">{{getCommentsList('public').length}}</span>
                        </div>
                        <div (click)="commentsNav = 'internal'"
                             [ngClass]="{'active mtv-primary-border': commentsNav == 'internal'}">
                            Internal
                            <span class="badge-total mtv-primary-bg-color">{{getCommentsList('internal').length}}</span>
                        </div>
                    </div>
                    <div class="comments-wrapper">
                        <div class="comments-row"
                             *ngFor="let comment of getCommentsList(!authenticationService.userIsResident ? commentsNav : 'public')"
                             [ngClass]="{internal: comment.isPrivate && !comment.isPublic}">
                            <div class="row">
                                <div class="bold col-md-7">{{comment.createdByName}}</div>
                                <div class="col-md-5 text-right">{{getCommentTime(comment)}}</div>
                            </div>
                            <div class="text m-t-xs">
                                <pre>{{comment.comment}}</pre>
                            </div>
                        </div>
                        <spinner [spinnerShow]="serviceRequestService.isCommentsLoading"></spinner>
                    </div>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'history'">
                    <div class="timeline remove-vertical-scrollbar" style="padding: 30px 40px;">
                        <spinner [spinnerShow]="serviceRequestService.spinnerShow"></spinner>
                        <ul class="timeline__list list-sideline-fix no-bottom-gap" *ngIf="!serviceRequestService.spinnerShow">
                            <li *ngFor="let a of serviceRequestService.activities" class="side-border-fix">
                                <i class="fa fa-eye-slash" aria-hidden="true"
                                   *ngIf="!authenticationService.userIsResident && activityIsPrivateComment(a)"></i>
                                <section *ngIf="a.action !== 'ignore' && !(authenticationService.userIsResident && activityIsPrivateComment(a))">
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div [ngSwitch]="a.action">
                                            <ng-template [ngSwitchCase]="'update'">
                                                    <span *ngIf="a.originActivityType != 'serviceRequestComment'">
                                                        {{ a.activityType }}
                                                        <span class="timeline__active">"{{a.name}}"</span>
                                                    </span>
                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        <div *ngIf="isNotObject(item.value)">
                                                            {{ item?.key }} :
                                                            <span class="timeline__active">"{{ item?.old }}"</span>
                                                            changed to
                                                            <span class="timeline__active">"{{ item?.new }}"</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                            <ng-template [ngSwitchCase]="'create'">
                                                <p *ngIf="a.originActivityType != 'serviceRequestComment'">
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.data[0].value}}"</span> was added
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                </p>

                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        <div *ngIf="isNotObject(item.value)">
                                                            {{ item.key }} :
                                                            <span class="timeline__active">{{ item.value }}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </ng-template>
                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>

                <hr *ngIf="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident">

                <div *ngIf="serviceRequestService.selectedItemData.isCanEdit && !authenticationService.userIsResident"
                     class="btn-group dropup">
                    <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu" *ngIf="serviceRequestService.selectedItemData.status != status.archived">
                        <li (click)="changeServiceRequestReadStatus($event, 1, serviceRequestService.selectedItemData)"
                            *ngIf="!serviceRequestService.selectedItemData.isRead">
                            <a>Mark as Read</a>
                        </li>
                        <li (click)="assignServiceRequestTo(serviceRequestService.selectedItemData, $event)"
                            *ngIf="serviceRequestService.selectedItemData.status === status.open
                                       && serviceRequestService.selectedItemData.isRead">
                            <a>Assign To</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.inProgress, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status === status.onHold">
                            <a>Resume</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.closed, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status === status.inProgress">
                            <a>Close</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.archived, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status === status.closed ||
                                       serviceRequestService.selectedItemData.status === status.cancelled">
                            <a>Archive</a>
                        </li>
                        <li (click)="changeServiceRequestReadStatus($event, -1, serviceRequestService.selectedItemData)">
                            <a>Add Comment</a>
                        </li>
                        <li (click)="changeServiceRequestReadStatus($event, 0, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.isRead">
                            <a>Mark as Unread</a>
                        </li>
                        <li (click)="assignServiceRequestTo(serviceRequestService.selectedItemData, $event)"
                            *ngIf="!(serviceRequestService.selectedItemData.status === status.open
                                        && serviceRequestService.selectedItemData.isRead)
                                        && serviceRequestService.selectedItemData.status !== status.closed
                                        && serviceRequestService.selectedItemData.status !== status.cancelled
                                        && !authenticationService.userIsResident">
                            <a>Assign To</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.onHold, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status !== status.onHold &&
                                       (serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled)">
                            <a>On Hold</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.closed, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status !== status.inProgress &&
                                       (serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled)">
                            <a>Close</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.cancelled, serviceRequestService.selectedItemData)"
                            *ngIf="(serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled)">
                            <a>Cancel</a>
                        </li>
                        <li (click)="changeServiceRequestStatus($event, status.archived, serviceRequestService.selectedItemData)"
                            *ngIf="serviceRequestService.selectedItemData.status == status.inProgress
                                       || serviceRequestService.selectedItemData.status == status.onHold &&
                                       (serviceRequestService.selectedItemData.status !== status.closed &&
                                       serviceRequestService.selectedItemData.status !== status.cancelled)">
                            <a>Archive</a>
                        </li>
                        <li (click)="serviceRequestService.getPdf(serviceRequestService.selectedItemData)">
                            <a>Get PDF</a>
                        </li>
                    </ul>
                    <ul class="dropdown-menu" *ngIf="serviceRequestService.selectedItemData.status == status.archived">
                        <li (click)="serviceRequestService.getPdf(serviceRequestService.selectedItemData)">
                            <a>Get PDF</a>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-detail-section/service-detail-section.component.html